import Text, { TextType } from '../../Text/Text';
import { classes, st } from './SectionTitle.st.css';
import settingsParams from '../../settingsParams';
import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import { SectionTitleDataHooks } from './dataHooks';
import { Divider } from 'wix-ui-tpa/cssVars';
import { TagName } from '../../../../utils/tagName.const';

export type SectionTitleProps = {
  label: string;
  tagName: TagName;
};

export function SectionTitle({ label, tagName }: SectionTitleProps) {
  const settings = useSettings();

  return (
    <div
      className={st(classes.root, {
        textAlignment: settings.get(settingsParams.titlesAlignment),
      })}
    >
      <Text
        type={TextType.Title}
        data-hook={SectionTitleDataHooks.LABEL}
        className={classes.title}
        tagName={tagName}
      >
        {label}
      </Text>
      <Divider
        className={classes.divider}
        data-hook={SectionTitleDataHooks.DIVIDER}
      />
    </div>
  );
}
